import { render, staticRenderFns } from "./assetTypeList.vue?vue&type=template&id=669bac70&"
import script from "./assetTypeList.vue?vue&type=script&lang=js&"
export * from "./assetTypeList.vue?vue&type=script&lang=js&"
import style0 from "./assetTypeList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports